import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useState } from "react";
export function CarsToggleButton({ value, cars, valueChanged, }) {
    const [filtrShow, setFiltrShow] = useState(value);
    const [carsCount, setCarsCount] = useState(cars);
    useEffect(() => {
        valueChanged?.(filtrShow);
    }, [filtrShow]);
    useEffect(() => {
        // if (value === filtrShow) {
        // 	return;
        // }
        setFiltrShow(value);
        setCarsCount(cars);
    }, [value, cars]);
    return _jsx(_Fragment, { children: _jsxs("button", { className: "car-filtration-toggle", onClick: () => setFiltrShow(!filtrShow), children: [_jsx("span", { className: "car-filtration-toggle__icon icon icon--gear" }), "Filtrovat nab\u00EDdky", _jsx("span", { className: "car-filtration-toggle__count", children: carsCount })] }) });
}
